import { MissionAcceptanceStatus } from '@enums/mission-acceptance-status.enum';
import { StatusColor } from '@enums/status-color.enum';

export const MISSION_ACCEPTANCE_STATUS_COLOR: Record<MissionAcceptanceStatus, StatusColor> = {
  [MissionAcceptanceStatus.todo]: StatusColor.grey3,
  [MissionAcceptanceStatus.inProgress]: StatusColor.orange,
  [MissionAcceptanceStatus.toValidate]: StatusColor.orange,
  [MissionAcceptanceStatus.validated]: StatusColor.accent,
  [MissionAcceptanceStatus.ignored]: StatusColor.grey4
};
